import { ImgHTMLAttributes } from 'react';
import { logoEfexInvoice, poweredByEfex } from '../../../../assets';
import LogoControllerStyles from './LogoController.style';

type LogoProps = ImgHTMLAttributes<HTMLImageElement>;

interface LogoControllerProps {
  isWhiteLabel: boolean;
  whiteLabelLogo?: string;
  efexLogoProps?: LogoProps;
}

const LogoController = ({
  isWhiteLabel,
  whiteLabelLogo,
  efexLogoProps,
}: LogoControllerProps) => (
  <>
    {!isWhiteLabel && (
      <img
        {...efexLogoProps}
        src={logoEfexInvoice}
        alt="EFEX Logo"
        loading="lazy"
      />
    )}
    {isWhiteLabel && (
      <div
        className={LogoControllerStyles.wrapper}
        role="img"
        aria-label="Company branding"
      >
        {whiteLabelLogo && (
          <img
            src={whiteLabelLogo}
            className={LogoControllerStyles.mainLogo}
            alt="Company Logo"
            loading="lazy"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
            }}
          />
        )}
        <img
          src={poweredByEfex}
          className={LogoControllerStyles.poweredBy}
          alt="Powered by EFEX"
          loading="lazy"
        />
      </div>
    )}
  </>
);

export default LogoController;
